export enum InterfaceLanguage {
  PL = 'pl',
  // EN = 'en',
  // DE = 'de',
  // ES = 'es',
  // FR = 'fr',
  // IT = 'it',
}
